import { CommonDataService } from "@common/lib/data/common-data.service";

export abstract class BaseQueryUtilities {
    public constructor(protected commonDataService: CommonDataService) { }
}
